import ApplicationController from './application_controller'

export default class UpdateLabelController extends ApplicationController {
  static targets = ['label', 'input', 'selectElement']

  connect() {
    const preselectedInput = this.inputTargets.find(input => input.selected || input.checked);

    if (preselectedInput) {
      this.updateLabel(preselectedInput.dataset.quickInfo);
    }
  }

  updateLabel(newContent) {
    this.labelTarget.textContent = newContent;
  }

  updateLabelOnRadioChange(event) {
    this.updateLabel(event.currentTarget.dataset.quickInfo);
  }
}
